import API_END_POINTS from '../../../api/endpoints';
import { dataFetch } from '../../../api/data-fetch';

// initial state
const state = () => ({
  retrievedData: {},
});

// actions
const actions = {
  async fetchNextToPlay(state, fetcher = dataFetch) {
    const res = await fetcher(API_END_POINTS.NEXT_TO_PLAY.MULTIPLE_SPORTS);
    state.commit('SET_NEXT_TO_PLAY', { nextToPlayData: res });
  },
  async fetchRelatedEvents(state, eventId, fetcher = dataFetch) {
    const res = await fetcher(API_END_POINTS.NEXT_TO_PLAY.RELATED_EVENTS + '&eventId=' + eventId);
    res.sports = { events: res.events };
    state.commit('SET_NEXT_TO_PLAY', { nextToPlayData: res });
  },
};

// mutations
const mutations = {
  SET_NEXT_TO_PLAY: (state, { nextToPlayData }) => {
    state.retrievedData = nextToPlayData;
  },
};

// getter
const getters = {
  getData: state => {
    return state.retrievedData;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
